/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Premium_More_Feature1_TitleInputs */

const en_premium_more_feature1_title = /** @type {(inputs: Premium_More_Feature1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Custom Phrases`)
};

const ar_premium_more_feature1_title = /** @type {(inputs: Premium_More_Feature1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`عبارات مخصصة`)
};

const de_premium_more_feature1_title = /** @type {(inputs: Premium_More_Feature1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Benutzerdefinierte ermutigende Worte`)
};

const es_premium_more_feature1_title = /** @type {(inputs: Premium_More_Feature1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Frases personalizadas`)
};

const fr_premium_more_feature1_title = /** @type {(inputs: Premium_More_Feature1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Créer des paroles d’encouragement`)
};

const it_premium_more_feature1_title = /** @type {(inputs: Premium_More_Feature1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Frasi Personalizzate`)
};

const ja_premium_more_feature1_title = /** @type {(inputs: Premium_More_Feature1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`フレーズのカスタマイズ`)
};

const ko_premium_more_feature1_title = /** @type {(inputs: Premium_More_Feature1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`나만의 문구 설정`)
};

const pt_br_premium_more_feature1_title = /** @type {(inputs: Premium_More_Feature1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Frases personalizadas`)
};

const ru_premium_more_feature1_title = /** @type {(inputs: Premium_More_Feature1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Мотивирующие фразы`)
};

const th_premium_more_feature1_title = /** @type {(inputs: Premium_More_Feature1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ข้อความที่กำหนดเอง`)
};

const tr_premium_more_feature1_title = /** @type {(inputs: Premium_More_Feature1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Özel Sözler`)
};

const zh_cn_premium_more_feature1_title = /** @type {(inputs: Premium_More_Feature1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`自定义鼓励语句`)
};

const zh_tw_premium_more_feature1_title = /** @type {(inputs: Premium_More_Feature1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`自訂義鼓勵語句`)
};

/**
* | output |
* | --- |
* | "Custom Phrases" |
*
* @param {Premium_More_Feature1_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const premium_more_feature1_title = /** @type {((inputs?: Premium_More_Feature1_TitleInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Premium_More_Feature1_TitleInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_premium_more_feature1_title(inputs)
	if (locale === "ar") return ar_premium_more_feature1_title(inputs)
	if (locale === "de") return de_premium_more_feature1_title(inputs)
	if (locale === "es") return es_premium_more_feature1_title(inputs)
	if (locale === "fr") return fr_premium_more_feature1_title(inputs)
	if (locale === "it") return it_premium_more_feature1_title(inputs)
	if (locale === "ja") return ja_premium_more_feature1_title(inputs)
	if (locale === "ko") return ko_premium_more_feature1_title(inputs)
	if (locale === "pt_br") return pt_br_premium_more_feature1_title(inputs)
	if (locale === "ru") return ru_premium_more_feature1_title(inputs)
	if (locale === "th") return th_premium_more_feature1_title(inputs)
	if (locale === "tr") return tr_premium_more_feature1_title(inputs)
	if (locale === "zh_cn") return zh_cn_premium_more_feature1_title(inputs)
	return zh_tw_premium_more_feature1_title(inputs)
});